import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardMedia,
  Stack,
  Collapse,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ManageCollaboratorsModal from "../components/manageCollaborator";
import { useUser } from "../context/UserContext";
import Cookies from "js-cookie";

export default function ViewInsights() {
  const bucketUrl = "https://d39d8mfv7ni6v7.cloudfront.net/";
  const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
  const [insightsList, setInsightsList] = useState([]);
  const [expandedSection, setExpandedSection] = useState(null);
  const [showCollaboratorModal, setShowCollaboratorModal] = useState(false);
  const [collaborators, setCollaborators] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId } = useParams();
  const { isAdmin, roleName } = useUser();
  const extractNameFromEmail = (email) => {
    if (!email) return "";
    let name = email.split("@")[0];
    name = name.replace(/[.\-_]/g, " ");
    name = name.replace(/[0-9]/g, "");
    name = name.replace(/\s+/g, " ").trim();
    name = name
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

    return name;
  };

  const {
    surveyId,
    audienceGroupId,
    projectName,
    createdAt,
    bannerBookFiles = [],
    researchFiles = [],
    surveyFiles = [],
    bannerImagePath,
    fullProject,
  } = location.state || {};
  useEffect(() => {
    if (surveyId && audienceGroupId) {
      fetch(`${process.env.REACT_APP_API_URL}/avatar/segments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          survey_id: surveyId,
          audience_grp: audienceGroupId,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setInsightsList(data);
        })
        .catch((err) => console.error("Error fetching insights:", err));
    }
  }, [surveyId, audienceGroupId]);

  useEffect(() => {
    if (projectId) {
      fetchCollaborators();
    }
  }, [projectId]);

  const fetchCollaborators = async () => {
    try {
      const token = Cookies.get("token");

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/project/listOfCollaboratorAllProject`,
        {
          method: "POST",
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            project_id: projectId,
          }),
        },
      );

      const data = await res.json();
      if (res.ok && data.success && data.data && data.data.length > 0) {
        const collaboratorList = data.data || [];

        const mapped = collaboratorList.map((item) => ({
          id: item._id,
          name: extractNameFromEmail(item.email),
          email: item.email,
          permission: "Can View",
          status: item.isActive ? "active" : "pending",
        }));

        setCollaborators(mapped);
      } else {
        setCollaborators([]);
      }
    } catch (e) {
      setCollaborators([]);
    }
  };

  const handleCardClick = (user) => {
    navigate(
      `/projects/view/${projectId}/advisor/${user.segment_name || user.name}`,
      {
        state: {
          user,
          surveyId,
          audienceGroupId,
          projectName,
          createdAt,
          bannerBookFiles,
          researchFiles,
          bannerImagePath,
          fullProject,
        },
      },
    );
  };

  const handleSectionClick = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleFileClick = async (key) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/getS3Url`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            bucket:
              ENVIRONMENT === "production"
                ? "generativeinsight-user-survey"
                : "generativeinsight-user-survey-dev",
            key,
          }),
        },
      );

      const data = await res.json();

      if (data?.preSignedUrl) {
        window.open(data.preSignedUrl, "_blank");
      }
    } catch (err) {
      console.error("Failed to fetch S3 URL", err);
    }
  };

  const getFileIcon = (filePath) => {
    const ext = filePath.split(".").pop().toLowerCase();

    if (ext === "pdf") return "/json-media/icons/pdf.png";
    if (ext === "ppt" || ext === "pptx")
      return "/json-media/icons/ppt-icon.svg";

    return "/json-media/icons/file.png";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleCollaboratorModalClose = () => {
    setShowCollaboratorModal(false);
  };

  const handleBackNavigation = () => {
    navigate("/projects");
  };

  return (
    <div className={isAdmin ? "" : "dark-bg"}>
      <img
        src={bannerImagePath || "/json-media/img/view-banner.png"}
        alt="banner"
        className="viewTopBanner"
      />

      <Container align="center" className="generating-Insights">
        <Grid
          container
          spacing={3}
          justifyContent="center"
          className="insightList"
        >
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Stack
              direction="row"
              sx={{
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <Box textAlign="left">
                <span
                  style={{ cursor: "pointer" }}
                  onClick={handleBackNavigation}
                >
                  Projects /{" "}
                  <span className="white-text">
                    {projectName || "Tennessee Credit Union Research"}
                  </span>
                </span>
                <h2 style={{ fontWeight: 400 }} className="white-text m-0">
                  {projectName || "Tennessee Credit Union Research"}
                </h2>
                {createdAt && (
                  <span style={{ fontSize: "0.9rem", color: "#888" }}>
                    Created: {formatDate(createdAt)}
                  </span>
                )}
              </Box>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6 }}>
            <Stack
              direction="row"
              sx={{ justifyContent: "flex-end", marginBottom: 1.5 }}
            >
              <Box textAlign="left">
                {roleName?.toLowerCase() !== "collaborator" && (
                  <button
                    className="upload-page__create-button"
                    onClick={() => navigate("/create-survey")}
                  >
                    Conduct Follow-up Research
                  </button>
                )}
              </Box>
            </Stack>
          </Grid>
        </Grid>
        <br />
        <Box>
          <Grid
            container
            spacing={3}
            justifyContent="center"
            className="insightList"
          >
            {insightsList.map((user, index) => (
              <Grid item xs={12} sm={4} md={4} key={index}>
                <Card
                  className="cardBox"
                  onClick={() => handleCardClick(user)}
                  style={{ cursor: "pointer" }}
                >
                  <CardMedia
                    component="img"
                    height="180"
                    image={`${bucketUrl}${user?.avatar_id}.webp`}
                    alt={user.name}
                  />
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      padding: 2,
                    }}
                  >
                    <Box textAlign="left">
                      <div className="insight-name">
                        {user.name} ({user.age})
                      </div>
                      <span>{user.segment_name}</span>
                    </Box>
                    <Box>
                      <EastIcon className="white-text" sx={{ marginTop: 1 }} />
                    </Box>
                  </Stack>
                </Card>
              </Grid>
            ))}
          </Grid>
          <br />

          <Grid container spacing={3} className="insightList text-left">
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              <Card
                className="cardBox"
                sx={{
                  padding: 1.2,
                  height: "auto",
                  minHeight: 230,
                  overflow: "visible",
                }}
              >
                <Stack direction="row" sx={{}}>
                  <Box sx={{ padding: "0.5rem 0.7rem" }}>
                    <img
                      src={"/json-media/icons/ProjectFiles.svg"}
                      alt="files"
                      width={20}
                    />
                  </Box>
                  <Box textAlign="left" sx={{ paddingTop: 0.7 }}>
                    <b className="grey-text w400">Project Files</b>
                  </Box>
                </Stack>

                {bannerBookFiles.length > 0 && (
                  <>
                    <Stack
                      direction="row"
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: 1,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSectionClick("bannerBook")}
                    >
                      <Box textAlign="left">
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                          }}
                        >
                          <Box sx={{ padding: 1.2 }}>
                            <img
                              src={"/json-media/icons/folder.png"}
                              alt="folder"
                              width={25}
                            />
                          </Box>
                          <Box textAlign="left">
                            <div className="insight-name">Banner Book</div>
                            <span>{bannerBookFiles.length} files</span>
                          </Box>
                        </Stack>
                      </Box>
                      <Box>
                        {expandedSection === "bannerBook" ? (
                          <ExpandMoreIcon
                            className="white-text"
                            sx={{ marginTop: 1 }}
                          />
                        ) : (
                          <EastIcon
                            className="white-text"
                            sx={{ marginTop: 1 }}
                          />
                        )}
                      </Box>
                    </Stack>

                    <Collapse in={expandedSection === "bannerBook"}>
                      <Box sx={{ marginLeft: 4, marginBottom: 1 }}>
                        {bannerBookFiles.map((file, index) => (
                          <Stack
                            key={index}
                            direction="row"
                            sx={{
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              marginBottom: 1,
                              cursor: "pointer",
                            }}
                            onClick={() => handleFileClick(file.key)}
                          >
                            <Box textAlign="left">
                              <Stack direction="row">
                                <Box sx={{ padding: "4px 8px" }}>
                                  <img
                                    src="/json-media/icons/pdf.png"
                                    alt="file"
                                    width={20}
                                  />
                                </Box>
                                <Box>
                                  <div
                                    className="insight-name"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {file.name}
                                  </div>
                                </Box>
                              </Stack>
                            </Box>
                            <EastIcon
                              className="white-text"
                              sx={{ fontSize: 16 }}
                            />
                          </Stack>
                        ))}
                      </Box>
                    </Collapse>
                  </>
                )}

                {researchFiles.length > 0 && (
                  <>
                    <Stack
                      direction="row"
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: 1,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSectionClick("researchFindings")}
                    >
                      <Box textAlign="left">
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                          }}
                        >
                          <Box sx={{ padding: 1.2 }}>
                            <img
                              src={"/json-media/icons/ppt-icon.svg"}
                              alt="ppt"
                              width={25}
                            />
                          </Box>
                          <Box textAlign="left">
                            <div className="insight-name">
                              Research Findings Report
                            </div>
                            <span>{researchFiles.length} files</span>
                          </Box>
                        </Stack>
                      </Box>
                      <Box>
                        {expandedSection === "researchFindings" ? (
                          <ExpandMoreIcon
                            className="white-text"
                            sx={{ marginTop: 1 }}
                          />
                        ) : (
                          <EastIcon
                            className="white-text"
                            sx={{ marginTop: 1 }}
                          />
                        )}
                      </Box>
                    </Stack>

                    <Collapse in={expandedSection === "researchFindings"}>
                      <Box sx={{ marginLeft: 4, marginBottom: 1 }}>
                        {researchFiles.map((file, index) => (
                          <Stack
                            key={index}
                            direction="row"
                            sx={{
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              marginBottom: 1,
                              cursor: "pointer",
                            }}
                            onClick={() => handleFileClick(file.key)}
                          >
                            <Box textAlign="left">
                              <Stack
                                direction="row"
                                sx={{
                                  justifyContent: "space-between",
                                  alignItems: "flex-start",
                                }}
                              >
                                <Box sx={{ padding: "4px 8px" }}>
                                  <img
                                    src={"/json-media/icons/ppt-icon.svg"}
                                    alt="pptx"
                                    width={20}
                                  />
                                </Box>
                                <Box textAlign="left">
                                  <div
                                    className="insight-name"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {file.name}
                                  </div>
                                </Box>
                              </Stack>
                            </Box>
                            <Box>
                              <EastIcon
                                className="white-text"
                                sx={{ marginTop: 0.5, fontSize: 16 }}
                              />
                            </Box>
                          </Stack>
                        ))}
                      </Box>
                    </Collapse>
                  </>
                )}
                {surveyFiles.length > 0 && (
                  <>
                    <Stack
                      direction="row"
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: 1,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSectionClick("surveyFiles")}
                    >
                      <Box textAlign="left">
                        <Stack direction="row">
                          <Box sx={{ padding: 1.2 }}>
                            <img
                              src={"/json-media/icons/pdf.png"}
                              alt="pdf"
                              width={25}
                            />
                          </Box>
                          <Box textAlign="left">
                            <div className="insight-name">Survey</div>
                            <span>{surveyFiles.length} file(s)</span>
                          </Box>
                        </Stack>
                      </Box>
                      <Box>
                        {expandedSection === "surveyFiles" ? (
                          <ExpandMoreIcon
                            className="white-text"
                            sx={{ marginTop: 1 }}
                          />
                        ) : (
                          <EastIcon
                            className="white-text"
                            sx={{ marginTop: 1 }}
                          />
                        )}
                      </Box>
                    </Stack>

                    <Collapse in={expandedSection === "surveyFiles"}>
                      <Box sx={{ marginLeft: 4, marginBottom: 1 }}>
                        {surveyFiles.map((file, index) => (
                          <Stack
                            key={index}
                            direction="row"
                            sx={{
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              marginBottom: 1,
                              cursor: "pointer",
                            }}
                            onClick={() => handleFileClick(file.key)}
                          >
                            <Box textAlign="left">
                              <Stack direction="row">
                                <Box sx={{ padding: "4px 8px" }}>
                                  <img
                                    src={"/json-media/icons/pdf.png"}
                                    alt="pdf"
                                    width={20}
                                  />
                                </Box>
                                <Box>
                                  <div
                                    className="insight-name"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {file.name}
                                  </div>
                                </Box>
                              </Stack>
                            </Box>
                            <EastIcon
                              className="white-text"
                              sx={{ fontSize: 16 }}
                            />
                          </Stack>
                        ))}
                      </Box>
                    </Collapse>
                  </>
                )}
                {bannerBookFiles.length === 0 &&
                  researchFiles.length === 0 &&
                  surveyFiles.length ===
                    0(
                      <Box
                        sx={{ padding: 2, textAlign: "center", color: "#888" }}
                      >
                        No project files available
                      </Box>,
                    )}
              </Card>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <Card
                className="cardBox"
                sx={{
                  padding: 1.2,
                  height: "auto",
                  minHeight: 230,
                  overflow: "visible",
                }}
              >
                <Stack direction="row" sx={{}}>
                  <Box sx={{ padding: "0.5rem 0.7rem" }}>
                    <img
                      src={"/json-media/icons/Collaborators.svg"}
                      alt="collaborators"
                      width={20}
                    />
                  </Box>
                  <Box textAlign="left" sx={{ paddingTop: 0.7 }}>
                    <b className="grey-text w400">Collaborators</b>
                  </Box>
                </Stack>

                {collaborators.length === 0 ? (
                  <Box textAlign="center" sx={{ padding: "1.5rem 1rem" }}>
                    <Typography
                      variant="body1"
                      className="grey-text w400"
                      gutterBottom
                    >
                      No collaborators added yet
                    </Typography>
                    <button
                      className="upload-page__create-button"
                      style={{
                        background: "transparent",
                        border: "#fff solid 1px",
                        marginTop: 15,
                        padding: "12px 20px",
                      }}
                      onClick={() => setShowCollaboratorModal(true)}
                    >
                      <img
                        src={"/json-media/icons/iconplus.png"}
                        alt="add"
                        width={15}
                        style={{ marginRight: 8 }}
                      />
                      Add Collaborators
                    </button>
                  </Box>
                ) : (
                  <Box sx={{ padding: "1rem" }}>
                    {collaborators.map((collab, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.875rem",
                          marginBottom:
                            index < collaborators.length - 1 ? "1.25rem" : 0,
                        }}
                      >
                        <Box
                          sx={{
                            width: 42,
                            height: 42,
                            borderRadius: "50%",
                            backgroundColor: "#3b82f6",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "0.95rem",
                            fontWeight: 600,
                            flexShrink: 0,
                          }}
                        >
                          {collab.name
                            ? collab.name.charAt(0).toUpperCase()
                            : "?"}
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Typography
                            sx={{
                              color: "#ffffff",
                              fontWeight: 500,
                              fontSize: "1rem",
                              margin: 0,
                              lineHeight: 1.2,
                            }}
                          >
                            {collab.name}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.875rem",
                              color: "#9ca3af",
                              margin: 0,
                              lineHeight: 1.2,
                              marginTop: "2px",
                            }}
                          >
                            Can View
                            {collab.status === "pending" && (
                              <span
                                style={{
                                  border: "1px solid #ffffff",
                                  color: "#ffffff",
                                  fontSize: "11px",
                                  padding: "2px 10px",
                                  borderRadius: "999px",
                                  fontWeight: 500,
                                  letterSpacing: "0.3px",
                                  marginLeft: "10px",
                                }}
                              >
                                Pending
                              </span>
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                    <button
                      style={{
                        background: "transparent",
                        border: "2px solid #ffffff",
                        marginTop: "1.75rem",
                        padding: "12px 16px",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        borderRadius: "50px",
                        fontSize: "1rem",
                        fontWeight: 500,
                        color: "#ffffff",
                      }}
                      onClick={() => setShowCollaboratorModal(true)}
                    >
                      <img
                        src={"/json-media/icons/Collaborators.svg"}
                        alt="collaborators"
                        width={20}
                        height={20}
                      />
                      Manage Collaborators
                    </button>
                  </Box>
                )}
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <ManageCollaboratorsModal
        isOpen={showCollaboratorModal}
        onClose={handleCollaboratorModalClose}
        projectId={fullProject?._id || projectId}
        onCollaboratorsUpdated={() => {
          fetchCollaborators();
        }}
      />
    </div>
  );
}
